export default __webpack_public_path__ + "media/icons/warning-red-c189f320.png";